import { InfoItem } from "@/components/info-item";
import { useAppSelector } from "@/app/appStore";
import { selectSelectedEvent } from "@/entities/annotation";
import { PREDICTION_TYPES } from "@/entities/annotation/model/consts";
import { formatTimestamp } from "../../lib/helpers";
import { formatAbsoluteCoordinates } from "@/shared";
import ProductItem from "../../ui/product-item";

const ZoneBasedPredictionDetails = () => {
  const selectedEvent = useAppSelector(selectSelectedEvent);

  if (!selectedEvent || selectedEvent.type !== PREDICTION_TYPES.ZONE) {
    return null;
  }

  const pinCoordinates = formatAbsoluteCoordinates(
    selectedEvent?.pinCoordinates?.relativeX,
    selectedEvent?.pinCoordinates?.relativeY,
    selectedEvent?.cameraImageWidth,
    selectedEvent?.cameraImageHeight
  );

  return (
    <>
      <InfoItem label="Event type" value="Zone Based Prediction" />
      <InfoItem
        label="Timestamp"
        value={
          selectedEvent?.timestamp && formatTimestamp(selectedEvent?.timestamp)
        }
        copyValue={selectedEvent?.timestamp}
      />
      <InfoItem label="Pin coordinates (x,y)" value={pinCoordinates} />
      <InfoItem
        label="Camera image dimensions"
        value={`${selectedEvent?.cameraImageWidth}x${selectedEvent?.cameraImageHeight}`}
      />
      <InfoItem label="Action" value={selectedEvent.action} />
      <InfoItem label="Camera ID" value={selectedEvent.cameraId} />
      <InfoItem label="Calibration ID" value={selectedEvent.calibrationId} />
      <InfoItem label="Gondola name" value={selectedEvent.gondolaName} />
      <InfoItem label="Gondola ID" value={selectedEvent.gondolaId} />
      <InfoItem
        label="Update change camera ID"
        value={selectedEvent.updateChangeCameraId}
      />
      <InfoItem
        multiRow={!!selectedEvent.updateChangeStartTime}
        label="Update change start time"
        value={selectedEvent.updateChangeStartTime}
      />
      <InfoItem
        multiRow={!!selectedEvent.updateChangeEndTime}
        label="Update change end time"
        value={selectedEvent.updateChangeEndTime}
      />

      <ProductItem
        name={selectedEvent.name}
        imageUrl={selectedEvent.imageUrl}
        barcode={selectedEvent.barcode}
        skuId={selectedEvent.skuId}
        quantity={selectedEvent.count}
      />
    </>
  );
};

export default ZoneBasedPredictionDetails;
